module.exports = __webpack_public_path__ + "static/media/banner-bg-homepage.5f8ffe40.jpg";